import { SCHEMA_VERSION, normalizeWorkspace } from '../../contracts/schemas.js'

export function createBackupRepository({ workspaceRepository, dataRepository, imageRepository } = {}) {
  return {
    async export(selection = {}) {
      const items = {}
      if (selection.workspace !== false) items.workspace = workspaceRepository?.load?.().value || normalizeWorkspace(null)
      if (selection.config && dataRepository) items.config = dataRepository.config.load()
      if (selection.prompts && dataRepository) items.prompts = dataRepository.prompts.load()
      if (selection.groups && dataRepository) items.groups = dataRepository.groups.load()
      if (selection.outputs && dataRepository) items.outputs = dataRepository.outputs.load()
      if (selection.images && imageRepository?.list) items.images = await imageRepository.list()
      return { kind: 'iwb-v4-backup', schemaVersion: SCHEMA_VERSION.backup, exportedAt: new Date().toISOString(), includes: Object.keys(items), items }
    },
    async import(payload, { replace = false } = {}) {
      if (!payload || !['iwb-v4-backup', 'backup'].includes(payload.kind) || Number(payload.schemaVersion || 0) > SCHEMA_VERSION.backup + 1) return { ok: false, code: 'backup.unsupported' }
      const items = payload.items && typeof payload.items === 'object' ? payload.items : {}
      if (items.workspace) workspaceRepository?.save?.(normalizeWorkspace(items.workspace))
      if (items.config && dataRepository) dataRepository.config.save(items.config)
      if (items.prompts && dataRepository) dataRepository.prompts.save(items.prompts)
      if (items.groups && dataRepository) dataRepository.groups.save(items.groups)
      if (items.outputs && dataRepository) dataRepository.outputs.save(items.outputs)
      if (items.images && imageRepository?.put) for (const image of items.images) await imageRepository.put(image)
      return { ok: true, replaced: replace, includes: payload.includes || Object.keys(items) }
    },
  }
}
